export default __webpack_public_path__ + "static/media/quick-action-purple.186f40b3.svg";